import 'css-chunksrc/client/scenes/constrainElement/constrainedElement/element/list/styles.scss';export default {
  "list": "_list_1w3v8_1",
  "unScheduled": "_unScheduled_1w3v8_6",
  "project": "_project_1w3v8_6",
  "completed": "_completed_1w3v8_12"
};